export default {
    /**
     * @description 配置显示在浏览器标签的title
     */
    title: '新潮传媒运维平台',
    /**
     * @description token在Cookie中存储的天数，默认1天
     */
    cookieExpires: 1,
    base: location.protocol + '//' + document.domain,
    baseUrl: this.base + '/api/v1',
    auth: this.base + '/login/ldap',
    logout: this.base + '/logout'
}



// WEBPACK FOOTER //
// ./src/config/index.js